<!-- eslint-disable max-len -->
<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="34" height="34" rx="17" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.9991 28.5C19.0558 28.5 19.112 28.4981 19.1678 28.4944C19.278 28.4981 19.3887 28.5 19.5 28.5C25.1353 28.5 29.5 23.683 29.5 18C29.5 12.317 25.1353 7.5 19.5 7.5C19.3887 7.5 19.278 7.50188 19.1678 7.5056C19.112 7.50189 19.0558 7.5 18.9991 7.5H16C10.5254 7.5 6.5 12.4436 6.5 18C6.5 23.5564 10.5254 28.5 16 28.5H18.9991ZM8.5 18C8.5 14.7175 10.1417 11.8696 12.5454 10.4534C10.6556 12.3808 9.5 15.0757 9.5 18C9.5 20.9243 10.6556 23.6192 12.5454 25.5466C10.1417 24.1304 8.5 21.2825 8.5 18ZM27.5 18C27.5 22.6944 23.9183 26.5 19.5 26.5C15.0817 26.5 11.5 22.6944 11.5 18C11.5 13.3056 15.0817 9.5 19.5 9.5C23.9183 9.5 27.5 13.3056 27.5 18Z"
      fill="#666666"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 13.5C20.5523 13.5 21 13.9477 21 14.5V17.5H24C24.5523 17.5 25 17.9477 25 18.5C25 19.0523 24.5523 19.5 24 19.5H21V22.5C21 23.0523 20.5523 23.5 20 23.5C19.4477 23.5 19 23.0523 19 22.5V19.5H16C15.4477 19.5 15 19.0523 15 18.5C15 17.9477 15.4477 17.5 16 17.5H19V14.5C19 13.9477 19.4477 13.5 20 13.5Z"
      fill="#666666"
    />
    <rect x="1" y="1" width="34" height="34" rx="17" stroke="#666666" stroke-width="2" />
  </svg>
</template>
